export default class Account {
  constructor() {
    this.summary = null;
    this.wealthProjection = null;
    this.targetPortfolio = null;
    this.currentPortfolio = null;
    this.batchId = null;
    this.toAdd = null;
    this.accountTypes = [];
  }
}
